<template>
  <div>
    <header>
      <div class="container-fluid">
        <div class="row justify-content-center" :style="{'background': '#F5F5F7'}">
            <img class="logo-header" src="../img/logo-ucm-header.png" alt="Logo UCM" @click="navigatesToForm" :style="{'cursor': 'pointer'}"/>
        </div>
      </div>
    </header>

     <!-- Loading gif -->
     <div v-if="showLoader" class="loader-overlay">
        <img src="../img/gif/kOnzy.gif" alt="Loading GIF" class="loader-gif">
     </div>
    <!--Sección SOS Rescate-->
    <div class="container-fluid" :style="{'background': '#fff'}">
      <div class="container align-middle">
      <div class="row">
        <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <h4>Tu iPhone pide ayuda cuando tú no puedes</h4>
                    <h1>Siéntete Seguro todo el año con <a href="" class="linkrescate"> <strong> SOS Rescate </strong> </a></h1>
                    <br />
                    <p> Un plan anual que es perfecto para ti y tu familia.
                        <strong>
                          Protégete las 24 hrs del día los 7 días de la semana
                        </strong>        
                    de accidentes de riesgo vital y situaciones que puedan poner en riesgo tu vida como:<br /><br />
                    <ul>
                        <li>Accidentes automovilísticos</li>
                        <li>Portonazos</li>
                        <li>Caídas desde altura</li>
                        <li>Accidentes traumáticos.</li>
                    </ul>
                    </p>
        </div>
        <!--Fin Sección SOS Rescate-->

        <!-- Form de solicitud -->
        <div class="container-fluid col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
          <div id="main-form" class="full-height p-2" :style="{'background': '#fff'}">
            <div class="col-lg-12 pt-4">
                  <div class="text-center mb-3 d-block d-lg-none">
                    <h1 class="display-6">{{ title }}</h1>
                  </div>
                    <div class="container border p-3 p-md-5 background-ucm shadow rounded">
                      <p class="font-ucm" :style="{'font-weigth':'bold','font-size': '1.7em'}">
                        Vamos a guiarte paso a paso para que te sientas tranquilo y seguro las 24 hrs del día
                      </p>
                      <!-- <p class="font-ucm" :style="{'font-size': '1.1em', 'margin-bottom': '6%'}">Completa el formulario para recibir información que te guiará para configurar tu IPhone</p> -->

                          <form @submit.prevent="sendEmail">
                                <div class="form-group">
                                  <p></p>
                                    <p v-if="errors.length" class="font-ucm" :style="{'text-align' : 'left'}">
                                      <b :style="{'text-align' : 'center'}">Por favor, corrija el(los) siguiente(s) error(es):</b>
                                        <ul>
                                          <li v-for="error in errors">{{ error }} </li>
                                        </ul>
                                    </p>
                                  <p></p>
                              
                                  <div class="col" :style="{ 'margin-top': '5px', 'margin-bottom': '12px' }">
                                    <input type="text"
                                            v-model="name"
                                            name="name"
                                            placeholder="Nombre"
                                            class="form-control"
                                            :style="{ 'font-weight': '600', 'font-size': '16px' }" @input="validateString"/>
                                  </div>
                              
                                  <input 
                                        type="text"
                                        v-model="lastName"
                                        name="lastName"
                                        placeholder="Apellido Paterno"
                                        class="form-control"
                                        :style="{ 'font-weight': '600', 'font-size': '16px', 'margin-bottom': '12px' }" @input="validateString"/>
                                  <input
                                        type="text"
                                        v-model="lastNameMother"
                                        name="lastNameMother"
                                        placeholder="Apellido Materno"
                                        class="form-control"
                                        :style="{ 'font-weight': '600', 'font-size': '16px', 'margin-bottom': '12px' }" @input="validateString"/>
                                
                                  <input
                                      type="text"
                                      id="rut"
                                      v-model="rut"
                                      name="rut"
                                      placeholder="RUT"
                                      class="form-control"
                                      :style="{
                                      'font-weight': 'bold',
                                      'font-size': '16px',
                                      'margin-bottom': '12px'}"
                                      :maxlength="maxRutChar"
                                      @input="FormatRut()"/>

                                  <input
                                      type="email"
                                      v-model="email"
                                      name="email"
                                      placeholder="Correo electrónico"
                                      class="form-control"
                                      :style="{
                                      'font-weight': 'bold',
                                      'font-size': '16px',
                                      'margin-bottom': '12px'
                                      }"/>

                                  <input
                                      type="text"
                                      v-model="address"
                                      name="address"
                                      placeholder="Dirección y comuna"
                                      class="form-control"
                                      :style="{
                                      'font-weight': 'bold',
                                      'font-size': '16px',
                                      'margin-bottom': '12px'
                                      }"/>
                                    
                                  <div class="row" :style="{ 'margin-bottom': '22px' }">
                                      <div class="col col-md-2">
                                        <input
                                            placeholder="+569"
                                            class="form-control"
                                            :style="{ 'font-weight': 'bold', 'font-size': '16px' }"
                                            disabled/>
                                        </div>

                                      <div class="col">
                                        <input
                                            type="text"
                                            v-model="phone"
                                            :maxlength="maxChar"
                                            name="phone"
                                            placeholder="Número de teléfono"
                                            class="form-control"
                                            :style="{ 'font-weight': 'bold', 'font-size': '16px' }"
                                            @input="validateNumbers"/>
                                      </div>
                                  </div>

                                  <div class="row" :style="{ 'margin-bottom': '22px' }">
                                      <div class="col">
                                        <select v-model="gender" name="gender" class="form-control" :style="{ 'font-weight': 'bold', 'font-size': '16px' }" :class="{selected: isSelected}">
                                          <option value="" disabled>...</option>
                                          <option value="masculino">Masculino</option>
                                          <option value="femenino">Femenino</option>
                                        </select>
                                      </div>
                                  </div>

                                  <div class="row" :style="{ 'margin-bottom': '22px' }">
                                      <!-- <div class="col">
                                        <label :style="{'transform': 'translateY(-50%)', 'color': '#999', 'pointer-event': 'none'}" v-if="!birthdate">Fecha de nacimiento</label>
                                        <input
                                            type="date"
                                            v-model="birthdate"
                                            name="birthdate"
                                            class="form-control"
                                            :style="{ 'font-weight': 'bold', 'font-size': '16px' }">
                                      </div> -->
                                      <div class="col">
                                        <!-- <label :style="{'transform': 'translateY(-50%)', 'color': '#999', 'pointer-event': 'none'}" v-if="!birthdate">Fecha de nacimiento</label> -->
                                        <input type="text" 
                                               v-model="birthdate"
                                               name="birthdate"
                                               id="birthdate" 
                                               class="form-control" 
                                               placeholder="Fecha de nacimiento" 
                                               :style="{ 'font-weight': 'bold', 'font-size': '16px' }" 
                                               readonly/>
                                      </div>
                                  </div>
                                
                                  <!-- <small id="emailHelp" class="form-text text-light">Tu información es confidecial, no compartiremos tu información</small> -->
                                  <p :style="{'margin-left': '10%', 'margin-rigth': '20%', 'width': '85%', 'text-align': 'center', 'font-size': '15px !important'}">
                                      <input type="checkbox" id="checkbox" v-model="checked"/>
                                      <small id="emailHelp" class="font-ucm text-light ml-2">
                                              Acepto los <strong><a :href="fileAgreement" target="_blank" :style="{'text-decoration': 'none'}">Términos y condiciones del servicio</a></strong>
                                      </small>
                                  </p>
                                    <button type="submit" value="Send" class="btn boton_azul" :style="{'margin-left': '10%', 'margin-rigth': '20%', 'width': '85%', 'text-align': 'center'}" @click.prevent="handleWebpaySend"> 
                                      Quiero contratar
                                    </button>
                                </div>
                          </form>

                            <Transition name="slide">
                              <div id="available" v-if="token" class="p-2" >
                                <h4 class="text-center mb-2 mt-3" :style="{ 'font-weight': '500', 'width': '100%', 'color': '#FFF'}">
                                    Puedes pagar con
                                </h4>
                                <div class="row">
                                  <!-- <div class="col my-auto">
                                    <button @click="mercadopago" :style="{ background: '#0000', border: '#0000' }">
                                        <img src="../img/mercadopago.png" class="float-right img-fluid app_store_img"/>
                                    </button> 
                                  </div> -->

                                  <div class="col my-auto">
                                    <!-- form transbank WEBPAY PLUS-->
                                    <form :action="urlTransactionWP" method="POST">
                                      <input type="hidden" name="token_ws" :value="token"/>
                                      <!-- <input type="submit" value="Pagar" /> -->

                                      <button type="submit" :style="{ background: '#0000', border: '#0000'}">
                                        <img src="../img/transbank.png" class="img-fluid" :style="{'margin-left': '15%', 'margin-right': '25%', 'width': '100%'}"/>
                                      </button>
                                    </form>
                                    <div class="mt-4" :style="{'text-align': 'center' }">
                                      <p class="m-0 text-light" v-if="okSend" :style="{'font-size': '1.2em'}">Una vez finalices el pago, se enviará un mail a tu dirección de correo. En caso de que no lo recibas, por favor, revisa la bandeja de correo no deseado (Spam).</p>
                                    </div>
                                    <!-- form transbank WEBPAY PLUS-->
                                  </div>

                                </div>
                              </div>
                            </Transition>
                    </div>               
            </div>
          </div>
        </div>
        <!-- Fin Form de solicitud -->
      </div> 
    </div>
  </div>
    <!-- FOOTER -->
    <div id="footer" class="p-4">
      <footer class="text-light p-4">
        <a href="https://www.ucmchile.cl/" target="_blank" :style="{'color': 'white'}">
            <small> Unidad Coronaria Móvil - Unidad Médica 2022 &copy;</small>
        </a>
      </footer>
    </div>
  </div>
</template>

<!-- SCRIPTS -->
<script>
  import axios from "axios";
  import { validateRut } from '@fdograph/rut-utilities';
  import 'jquery-ui/ui/widgets/datepicker';
  import 'jquery-ui/ui/i18n/datepicker-es';
  import 'jquery-ui/ui/widgets/datepicker';
  // import { create } from "domain";
  // import emailjs from "emailjs-com";
  // import { WebpayPlus } from 'transbank-sdk';
  // const WebpayPlus = require("transbank-sdk").WebpayPlus;
  // import { Auth } from '@/firebase/auth.js';
  // var mercadopago = require("mercadopago");

  const URL_DEV_MP = "http://localhost:3000/payment/new";
  const URL_PROD_MP = "https://35.87.22.14:8443//payment/new"; 
  const URL_DEV_WEBPAY = "http://localhost:3000/webpay";
  const URL_PROD_WEBPAY = "https://35.87.22.14:8443/webpay";


export default {

  data() {
    return {
      errors: [],
      title: "",
      precio: "240",
      name: "",
      lastName: "",
      lastNameMother: "",
      rut: "",
      email: "",
      address: "",
      phone: "",
      maxChar: 8,
      maxRutChar: 10,
      gender: "",
      message: "",
      minDate: '1910-01-01',
      maxDate: '2005-12-31',
      birthdate: null,
      scTimer: 0,
      scY: 0,
      checked: false,
      okSend: false,
      fileAgreement: 'https://ucm-landingpage.s3.sa-east-1.amazonaws.com/files_ucm/UCMContrato.pdf',
      token: '',
      dateNow: new Date().getDate() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getFullYear(),
      hourNow: new Date().getHours() + ':' + new Date().getMinutes(),
      endAgre: new Date().getDate() + '/' + (new Date().getMonth() + 1) + '/' + (new Date().getFullYear() + 1),
      showLoader: false,
      urlTransactionWP: 'https://webpay3g.transbank.cl:443/webpayserver/initTransaction', // 'https://webpay3gint.transbank.cl/webpayserver/initTransaction', // 
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    $("#birthdate").datepicker({
      changeMonth: true,
      changeYear: true,
      yearRange: "1910:2023",
      prevText: '',
      nextText: '',
      onSelect: (date) => {
        this.birthdate = date;
      },
      beforeShow: function(input, inst){
        inst.dpDiv.css({
          "background-color": "white",
          "border": "1px solid #ccc",
          "border-radius": "4px",
          "box-shadow": "0 2px 5px rgba(0, 0,  0, 0.15)",
          "padding": "10px",
          "z-index": "9999"
        });
      },
      
    });
  },
  computed: {
    isSelected() {
      return this.gender !== '';
    }
  },
  methods: {
    async handleWebpaySend() {
      $( "#datepicker" ).datepicker();
      this.errors = [];
      if(this.name && this.name.length <= 1) this.errors.push('El nombre debe tener al menos 2 caracteres.');
      if(this.lastName && this.lastName.length <= 1) this.errors.push('El apellido debe tener al menos 2 caracteres.');
      if(this.rut && this.rut.length <= 8) this.errors.push('El RUT es demasiado corto.');
      if(this.rut && !this.validateFormatRut(this.rut)) this.errors.push('El RUT no es valido.');
      if(this.phone && this.phone.length <= 4) this.errors.push('El telefono es demasiado corto.');
      if(this.email.length > 0 && !this.validatedEamil(this.email)) this.errors.push('El email es incorrecto.');
      // if(!this.validateDate(this.birthdate)) this.errors.push('Fecha de nacimiento debe ser DD/MM/YYYY');
      if(!this.checked) this.errors.push('Debe aceptar terminos y condiciones.');

      if(this.name && this.lastName && this.rut && this.validateFormatRut(this.rut) && this.email && this.address && this.phone && this.gender && this.birthdate && this.checked) {
        await this.webpay();
      } else {
        this.errors.push('Debe completar todos los campos.');
      }
    },

    validatedEamil(email) {
      const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(email);
    },

    validateString() {
      const regex = /^[A-Za-z]+$/;
      if(!regex.test(this.name) || !regex.test(this.lastName) || !regex.test(this.lastNameMother)) {
        this.name = this.name.replace(/\d/g, '');
        this.lastName = this.lastName.replace(/\d/g, '');
        this.lastNameMother = this.lastNameMother.replace(/\d/g, '');
      }
    },

    validateNumbers() {
      const regex = /^\d+$/;
      if(!regex.test(this.rut) || !regex.test(this.phone)) {
        this.rut = this.rut.replace(/\D/g, '');
        this.phone = this.phone.replace(/\D/g, '');
      }
    },

    validateDate() {
      const regex = /^\d{2}\/\d{2}\/\d{4}$/; // Expresión regular para formato DD/MM/YYYY
      return regex.test(this.birthdate)
    },

    validateFormatRut(data){
      const validate = validateRut(data);
      return validate;
    },

    FormatRut(){
      let rut = this.rut.replace(/[^0-9kK]/g, '');
      if(rut.length > 1 ) {
        rut = rut.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, '') + '-' + rut.slice(-1);
      }
      this.rut = rut;
    },

    navigatesToForm(event) {
      event.preventDefault();
      this.$router.push('/');
    },

    openFile(event) {
      event.preventDefault();
      window.open(this.fileAgreement, '_blank');
    },

    async mercadopago() {
      console.log("Selecciona MP");
      const optionsMP = {
                          method: "POST",
                          url: URL_DEV_MP,
                          headers: {
                            "Content-Type": "application/json"
                          },
                          data: {
                            name: "Servicio Alerta UCM",
                            unit: 1,
                            img: null
                          }
                        };
      axios(optionsMP)
        .then(async response => {
          if (response.status == 200) {
            window.open(response.data.url, "_blank", "noreferrer");
          } else {
            console.log(response);
          }
          // console.log(response);
        })
        .catch(error => console.log(error));
      // mercadopago.preferences.create(preference)
    },

    async webpay() {
      this.showLoader = true;

      const optionsWP = {
        url: URL_PROD_WEBPAY,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data:{
          name : this.name,
          lastName : this.lastName,
          lastNameMother: this.lastNameMother,
          rut : this.rut,
          email : this.email,
          address : this.address,
          phone : this.phone,
          gender : this.gender,
          birthdate : this.birthdate,
          dateNow: this.dateNow,
          hourNow: this.hourNow,
          endAgre: this.endAgre,
        }
      }

      axios(optionsWP).then(async response => {
        const { token, url } = response.data.data;
        this.token = token;
        this.url = url;
        this.okSend = true;
        this.showLoader = false;
        // this.clearForm();
      }).catch(error => {
        console.log(error);
        this.showLoader = false;
      });
    },

    // async sendEmail(data) { 
    //   const options = {
    //     url: URL_PROD_MAILGUN,
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     data:{
    //       name : this.name,
    //       lastName : this.lastName,
    //       rut : this.rut,
    //       email : this.email,
    //       address : this.address,
    //       phone : this.phone,
    //       gender : this.gender,
    //       birthdate : this.birthdate,
    //       dateNow: this.dateNow,
    //       hourNow: this.hourNow,
    //       endAgre: this.endAgre,
    //     }
    //   }
    //   axios(options).then(async response => {
    //     if(response) {
    //       console.log(response.data);
    //       this.okSend = true;
    //       this.name = "";
    //       this.lastName = "";
    //       this.rut = "";
    //       this.email = "";
    //       this.address = "";
    //       this.phone = "";
    //       this.gender = "";
    //       this.birthdate = "";
    //     }
    //   }).catch(error => console.log(error));
    // },
    
    async clearForm() {
      this.name = "";
      this.lastName = "";
      this.lastNameMother = "";
      this.rut = "";
      this.email = "";
      this.address = "";
      this.phone = "";
      this.gender = "";
      this.birthdate = "";
      this.checked = !this.checked;
    },

    // async sendEmail(data) {
    // try {
    //   emailjs.send(
    //     "service_7qohhge",
    //     "template_uzf20os",
    //     data,
    //     "hNS9R6z6TYyrDofuo",
    //     // OLD
    //     // "service_3m4zxce",
    //     // "template_30rao9y",
    //     // e.target,
    //     // "OseaJXmJpQdHR6Djw",
    //     {
    //       name: this.name,
    //       lastName: this.lastName,
    //       rut: this.rut,
    //       email: this.email,
    //       address: this.address,
    //       phone: this.phone,
    //       dateNow: this.dateNow,
    //       hourNow: this.hourNow,
    //       endAgre: this.endAgre,
    //       gender: this.gender,
    //       birthdate: this.birthdate
    //     }
    //   );
    // } catch (error) {
    //   console.log(error);
    // }
    // }
  }
};
</script>

<style scoped>
  #main-form {
    background-color: #F5F5F7;
    /* background: url("../assets/bg_mt_1.jpg") no-repeat center center; */
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }

  #footer {
    background-color: #252223;
    padding: 10px;
    text-align: center;
    position: relative;
    bottom: 0;
    width: 100%;
  }

  .background-ucm {
    background: #333;
  }

  .font-ucm {
    color: #fff;
    font-weight: 500;
    font-size: 20px;
    text-align: center;
  }

.app_store_img {
  max-width: 300px;
  max-height: 100px;
  border-radius: 2px;
  position: center;
}

.ipadstyle {
  font-size: 15px;
  font-weight: 400;
  /* color: white; */
  background-color: #333;
  font-family: inherit;
}

.text-ucm {
  color: #2b588a;
  font-weight: bold;
  font-family: inherit;
}

.text-bold {
  font-weight: bold;
}
.subtitle-ucm {
  border-bottom: 2px solid transparent;
  /* height: 100%; */
  border-radius: 0;
  color: #fff;
  padding: 10px 20px;
  font-size: 26px;
  font-weight: 600;
}

nav {
    position: relative;
    margin: 5px auto 0;
    width: 350px;
    height: 50px;
    background: #333;
    border-radius: 8px;
    font-size: 0;
    /* box-shadow: 0 2px 3px 0 rgba(0, 0, 0, .1);  */
}

nav a {
    font-size: 15px;
    text-transform: uppercase;
    color: #F5F5F7;
    text-decoration: none;
    line-height: 50px;
    position: relative;
    z-index: 1;
    display: inline-block;
    text-align: center;
}

#myBtn {
  display: none;
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 99;
  font-size: 18px;
  border: none;
  outline: none;
  background-color: red;
  color: #F5F5F7;
  cursor: pointer;
  padding: 15px;
  border-radius: 4px;
}

#myBtn:hover {
  background-color: #555;
}

.hr-line{
  width: 60%;
  margin: auto;
}

.active:after {
    content: "\2796";
    /* Unicode character for "minus" sign (-) */
}

.help-body {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background: #efefef; */
  line-height: 1.5;
}
#help{
  width: 1100px;
  max-width: 100%;
  margin: 0 auto;
}
.row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.card {
  flex: 1 1 20rem;
  display: flex;
  align-items: center;
  margin: 10px 20px;
  flex-direction: column;
  background: #fff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 4);
  padding: 10px 20px;
  align-self: normal;
}
.card img {
  max-width: 300px;
}
.card h4 {
  font-size: 1.3rem;
  text-align: uppercase;
  margin: 10px 0;
  color: #0070a3;
}
.card p {
  margin-bottom: 10px;
  font-weight: 600;
}

.selected {
  background-color: #E8F0FE;
}
.slide-enter-active, .slide-leave-active {
  transition: transform 0.4s;
}
.slide-enter, .slide-leave-to {
  transform: translateY(-25%);
}
/* loader gif */
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader-gif {
  width: 100px;
  height: 100px;
}
</style>




// WEBPACK FOOTER //
// src/components/Form.vue